<script setup>
import { useI18n } from 'vue-i18n';
import { useSupportTicketFormatters } from '../composables/useSupportTicketFormatters';

defineProps({
  selectedAssistanceTicket: { type: Object, default: () => ({}) },
  selectedMaintenanceCase: { type: Object, default: null },
  selectedWorkOrder: { type: Object, default: null },
  assistanceContextOptions: { type: Array, default: () => [] },
  assistanceSeverityOptions: { type: Array, default: () => [] },
  assistanceCategoryOptions: { type: Array, default: () => [] },
});

const { t } = useI18n();
const { assistanceLabel, humanizeAssistanceValue } =
  useSupportTicketFormatters();
</script>

<template>
  <div class="grid gap-3 md:grid-cols-3">
    <div
      class="rounded-lais border border-lais-border-soft bg-lais-bg px-3 py-2"
    >
      <p class="text-[11px] font-semibold text-lais-text-muted">
        {{ t('SUPPORT_TICKETS.ASSISTANCE.SUMMARY.TICKET') }}
      </p>
      <p class="mt-1 text-[13px] font-semibold text-lais-text">
        {{
          assistanceLabel(
            assistanceContextOptions,
            selectedAssistanceTicket.real_estate_context
          )
        }}
      </p>
      <p class="mt-1 text-[12px] text-lais-text-muted">
        {{
          assistanceLabel(
            assistanceSeverityOptions,
            selectedAssistanceTicket.severity
          )
        }}
      </p>
    </div>
    <div
      class="rounded-lais border border-lais-border-soft bg-lais-bg px-3 py-2"
    >
      <p class="text-[11px] font-semibold text-lais-text-muted">
        {{ t('SUPPORT_TICKETS.ASSISTANCE.SUMMARY.CASE') }}
      </p>
      <p class="mt-1 text-[13px] font-semibold text-lais-text">
        {{
          selectedMaintenanceCase
            ? humanizeAssistanceValue(selectedMaintenanceCase.status)
            : t('SUPPORT_TICKETS.ASSISTANCE.EMPTY_CASE')
        }}
      </p>
      <p class="mt-1 text-[12px] text-lais-text-muted">
        {{
          selectedMaintenanceCase
            ? assistanceLabel(
                assistanceCategoryOptions,
                selectedMaintenanceCase.category
              )
            : t('SUPPORT_TICKETS.ASSISTANCE.EMPTY_VALUE')
        }}
      </p>
    </div>
    <div
      class="rounded-lais border border-lais-border-soft bg-lais-bg px-3 py-2"
    >
      <p class="text-[11px] font-semibold text-lais-text-muted">
        {{ t('SUPPORT_TICKETS.ASSISTANCE.SUMMARY.WORK_ORDER') }}
      </p>
      <p class="mt-1 text-[13px] font-semibold text-lais-text">
        {{
          selectedWorkOrder
            ? humanizeAssistanceValue(selectedWorkOrder.status)
            : t('SUPPORT_TICKETS.ASSISTANCE.EMPTY_WORK_ORDER')
        }}
      </p>
      <p class="mt-1 text-[12px] text-lais-text-muted">
        {{
          selectedWorkOrder?.supplier_name ||
          t('SUPPORT_TICKETS.ASSISTANCE.NO_SUPPLIER')
        }}
      </p>
    </div>
  </div>
</template>
